import { makeStyles } from '@material-ui/core';

const customScrollbar = {
  scrollbarWidth: 'thin',
  scrollbarColor: '#d9042f4d transparent',
  '&::-webkit-scrollbar': {
    width: 6
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent'
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#d9042f4d',
    borderRadius: 10
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#d9042f8a'
  }
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '98%',
    margin: '0 auto',
    paddingTop: theme.spacing(2),
    // Desktop: cao đúng vùng nội dung dưới TopBar (DashboardLayout marginTop 66px),
    // phần còn lại do flex chia -> không thừa vài px gây scroll ngoài xộc xệch.
    // Không dùng height 100% vì các wrapper cha (ManageView) không có chiều cao xác định.
    [theme.breakpoints.up('md')]: {
      height: 'calc(100vh - 66px)',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      '& > *': {
        flexShrink: 0
      }
    }
  },
  searchBar: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '8px 8px 8px 20px',
    borderRadius: 14,
    border: '1px solid #eef1f6',
    boxShadow: '0 2px 14px rgba(15, 23, 42, 0.05)',
    transition: 'box-shadow .15s ease, border-color .15s ease',
    '&:focus-within': {
      borderColor: '#d9042f4d',
      boxShadow: '0 4px 18px rgba(217, 4, 47, 0.1)'
    }
  },
  searchClear: {
    color: '#8a8a8a',
    padding: 4,
    flexShrink: 0,
    '&:hover': {
      color: '#1E2323'
    }
  },
  searchWrapper: {
    position: 'relative',
    zIndex: 10
  },
  searchBarOpen: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: '#d9042f4d',
    boxShadow: '0 4px 18px rgba(217, 4, 47, 0.1)'
  },
  historyDropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    marginTop: -1,
    padding: '4px 0 8px',
    border: '1px solid #d9042f4d',
    borderTop: '1px solid #f0f2f5',
    borderRadius: '0 0 14px 14px',
    boxShadow: '0 10px 24px rgba(15, 23, 42, 0.12)',
    maxHeight: 360,
    overflowY: 'auto',
    ...customScrollbar
  },
  historyHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '6px 20px',
    fontSize: 12,
    color: '#8a8a8a'
  },
  historyClearAll: {
    cursor: 'pointer',
    color: '#1976d2',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  historyItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '4px 12px 4px 20px',
    minHeight: 38,
    fontSize: 14,
    color: '#1E2323',
    cursor: 'pointer',
    '&:hover $historyRemove': {
      visibility: 'visible'
    }
  },
  historyItemActive: {
    backgroundColor: '#f3f4f7',
    '& $historyRemove': {
      visibility: 'visible'
    }
  },
  historyIcon: {
    color: '#9aa0a6',
    fontSize: 20,
    flexShrink: 0
  },
  historyText: {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '& b': {
      fontWeight: 600
    }
  },
  historyRemove: {
    visibility: 'hidden',
    color: '#8a8a8a',
    padding: 4
  },
  searchIcon: {
    color: '#8a8a8a',
    fontSize: 22,
    flexShrink: 0
  },
  searchInput: {
    fontSize: 14
  },
  searchButton: {
    borderRadius: 10,
    padding: '10px 24px',
    textTransform: 'none',
    fontWeight: 600,
    boxShadow: 'none',
    flexShrink: 0
  },
  errorText: {
    color: '#D9534F',
    marginTop: 12
  },
  resultCard: {
    marginTop: 14,
    borderRadius: 16,
    border: '1px solid #eef1f6',
    boxShadow: '0 2px 14px rgba(15, 23, 42, 0.05)',
    overflow: 'hidden',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexDirection: 'column',
      flexShrink: '1 !important',
      minHeight: 0,
      marginBottom: theme.spacing(2)
    }
  },
  resultHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '16px 20px',
    borderBottom: '1px solid #f1f3f7'
  },
  resultHeaderIcon: {
    width: 40,
    height: 40,
    borderRadius: 12,
    background: 'linear-gradient(135deg, #fdecea, #fff6f6)',
    color: '#d9042f',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  },
  resultSubtitle: {
    fontSize: 13,
    color: '#6b7280',
    marginTop: 2,
    '& b': {
      color: '#1f2430',
      fontWeight: 600
    }
  },
  resultHint: {
    fontSize: 12,
    color: '#9aa1ad',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  resultTable: {
    maxHeight: 'calc(100vh - 280px)',
    [theme.breakpoints.up('md')]: {
      maxHeight: 'none',
      flex: '1 1 auto',
      minHeight: 0
    },
    ...customScrollbar
  },
  resultTableInner: {
    '& .MuiTableCell-root': {
      padding: '10px 12px',
      fontSize: 14,
      whiteSpace: 'nowrap'
    },
    '& .MuiTableCell-head': {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black
    }
  },
  resultBodyLoading: {
    opacity: 0.45,
    pointerEvents: 'none',
    transition: 'opacity .15s ease'
  },
  resultRow: {
    cursor: 'pointer',
    transition: 'background-color .12s ease',
    '&:hover': {
      backgroundColor: '#fff6f7',
      '& $rowChevron': {
        color: '#d9042f',
        transform: 'translateX(2px)'
      }
    },
    '&:last-child .MuiTableCell-root': {
      borderBottom: 'none'
    }
  },
  resultRowActive: {
    backgroundColor: '#fff0f2'
  },
  ellipsisText: {
    display: 'inline-block',
    maxWidth: 260,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    verticalAlign: 'middle'
  },
  chevronCell: {
    paddingLeft: '0 !important'
  },
  rowChevron: {
    color: '#c4c9d2',
    fontSize: 20,
    verticalAlign: 'middle',
    transition: 'color .12s ease, transform .12s ease'
  },
  resultPagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 15,
    padding: '10px 16px',
    borderTop: '1px solid #f1f3f7'
  },
  backButton: {
    alignSelf: 'flex-start',
    marginTop: 8,
    textTransform: 'none',
    fontWeight: 600
  },
  contentGrid: {
    marginTop: 4,
    [theme.breakpoints.up('md')]: {
      flex: '1 1 0 !important',
      minHeight: 0,
      marginBottom: 0,
      flexWrap: 'nowrap'
    }
  },
  gridCol: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      height: '100%'
    }
  },
  card: {
    padding: '18px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    borderRadius: 16,
    border: '1px solid #eef1f6',
    boxShadow: '0 2px 14px rgba(15, 23, 42, 0.05)'
  },
  configCard: {
    overflowY: 'auto',
    ...customScrollbar
  },
  emptyConfigText: {
    padding: theme.spacing(3, 0),
    textAlign: 'center',
    color: '#8a8a8a',
    fontSize: 14
  },
  cardBody: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    paddingRight: 6,
    marginTop: 10,
    ...customScrollbar
  },

  infoTabs: {
    flexShrink: 0,
    minHeight: 0,
    marginTop: theme.spacing(1),
    borderBottom: '1px solid #eef1f6',
    '& .MuiTab-root': {
      textTransform: 'none',
      fontSize: 14,
      fontWeight: 700,
      minHeight: 0,
      padding: theme.spacing(0, 1, 1.5)
    }
  },
  kvGroup: {
    border: '1px solid #eef1f6',
    borderRadius: 12,
    backgroundColor: '#fafbfc',
    padding: '10px 12px',
    marginBottom: 12
  },
  kvGroupTitle: {
    fontSize: 11,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
    color: '#8a8a8a',
    marginBottom: 6
  },
  kvRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8,
    fontSize: 13,
    padding: '4px 0'
  },
  kvLabel: {
    color: '#8a8a8a',
    flexShrink: 0
  },
  kvValue: {
    fontWeight: 600,
    color: '#1f2430',
    textAlign: 'right',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  // Giá trị dài hiển thị đầy đủ: xuống dòng, căn phải
  kvValueWrap: {
    fontWeight: 600,
    color: '#1f2430',
    textAlign: 'right',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    minWidth: 0
  },
  kvGroupButton: {
    marginTop: 8,
    width: 'auto'
  },
  mapButton: {
    borderRadius: 10,
    flexShrink: 0
  },
  plainTitle: {
    fontWeight: 700,
    fontSize: 15,
    color: '#1f2430'
  },
  mqttHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    marginBottom: 16,
    paddingBottom: 8,
    borderBottom: '2px solid #f5eeee',
    position: 'relative',
    flexShrink: 0,
    '&::after': {
      content: '""',
      position: 'absolute',
      left: 0,
      bottom: -2,
      width: 32,
      height: 2,
      backgroundColor: '#d9042f',
      borderRadius: 2
    }
  },
  connPillOn: {
    display: 'flex',
    alignItems: 'center',
    padding: '3px 10px',
    borderRadius: 20,
    backgroundColor: '#e6f4ea',
    color: '#28a745'
  },
  connPillOff: {
    display: 'flex',
    alignItems: 'center',
    padding: '3px 10px',
    borderRadius: 20,
    backgroundColor: '#fdecea',
    color: '#d9042f'
  },
  logBox: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    paddingRight: 6,
    ...customScrollbar
  },
  logItem: {
    borderLeft: '3px solid #666',
    borderRadius: 8,
    backgroundColor: '#fafbfc',
    padding: '6px 10px',
    marginBottom: 6
  },
  logItemHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 2
  },
  logPayload: {
    fontSize: 11,
    color: '#45485E',
    wordBreak: 'break-all'
  },
  statusHero: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '12px 14px',
    borderRadius: 12,
    background: 'linear-gradient(135deg, #ffffff, #f5f7fb)',
    border: '1px solid #eef1f6',
    marginBottom: 12
  },
  statusHeroIcon: {
    width: 48,
    height: 48,
    objectFit: 'contain'
  },
  warrantyBtn: {
    marginLeft: 'auto',
    alignSelf: 'flex-start',
    color: '#D9042F',
    backgroundColor: '#fde8ec',
    '&:hover': {
      backgroundColor: '#fbd0d8'
    }
  },
  statusHeroLabel: {
    fontSize: 12,
    color: '#8a8a8a',
    marginBottom: 4
  },
  chartBtn: {
    textTransform: 'none',
    fontSize: 11,
    padding: '2px 8px',
    minWidth: 'auto',
    color: '#0c5299',
    backgroundColor: '#e8f0fe',
    borderRadius: 6
  },
  driverLoginBtn: {
    textTransform: 'none',
    fontSize: 11,
    padding: '2px 8px',
    minWidth: 'auto',
    color: '#d9042f',
    backgroundColor: '#fff0f2',
    border: '1px solid #ffd6dc',
    borderRadius: 6,
    fontWeight: 600,
    '&:hover': {
      backgroundColor: '#ffe2e6',
      borderColor: '#d9042f'
    }
  },
  driverLogoutBtn: {
    textTransform: 'none',
    fontSize: 11,
    padding: '2px 8px',
    minWidth: 'auto',
    color: '#b91c1c',
    backgroundColor: '#fef2f2',
    border: '1px solid #fecaca',
    borderRadius: 6,
    fontWeight: 600,
    '&:hover': {
      backgroundColor: '#fee2e2',
      borderColor: '#b91c1c'
    }
  }
}));

export default useStyles;
